// extracted by mini-css-extract-plugin
module.exports = {"Page":"ContactInfo_Page__2walC"};